/**
 * 按钮/操作权限校验（与后台菜单 name 一致）
 */
import { isSuperAdmin } from '@/utils/superAdmin'

function matchPermission(name, permissionList, username, roles) {
  if (!name) return true
  if (isSuperAdmin(username, roles)) return true
  const list = permissionList || []
  if (list.includes(name)) return true

  const colonIndex = name.indexOf(':')
  if (colonIndex > 0) {
    const pageName = name.substring(0, colonIndex)
    if (list.includes(pageName)) {
      const hasButtonPerm = list.some(item => item.startsWith(pageName + ':') && item !== pageName)
      if (!hasButtonPerm) return true
    }
  }
  return false
}

export function checkPermission(value, permissionList, username, roles) {
  if (!value) return true
  if (Array.isArray(value)) {
    return value.some(name => matchPermission(name, permissionList, username, roles))
  }
  return matchPermission(value, permissionList, username, roles)
}

export default checkPermission



// WEBPACK FOOTER //
// ./src/utils/permission.js